import { Stack, useLocalSearchParams } from 'expo-router';

import { FruitSliceManagementPage } from '../../../../fruit-slices/components/FruitSliceManagementPage';
import { FruitSlicePageBackground } from '../../../../fruit-slices/components/FruitSlicePageBackground';

export default function ManageFruitSlicePage() {
    const { id } = useLocalSearchParams<{ id: string }>();

    return (
        <>
            <Stack.Screen options={{ title: 'Manage Fruit Slice' }} />
            <FruitSlicePageBackground>
                <FruitSliceManagementPage sliceId={id} />
            </FruitSlicePageBackground>
        </>
    );
}
